import { GET_POSTERS } from "../graphql/queries/posters";
import { useQuery } from "@apollo/client";

export const usePosters = () => {
  const { loading, error, data } = useQuery(GET_POSTERS);
  return {
    loading,
    data,
    error,
  };
};
